import React, {useState} from 'react';
import './overlay-text-image.css'

const OverlayTextImage = ({title="Add Title", text="Add Text", slogan="Add Text", image="", alt="" })=> {

    return (
        <div className="overlay-text-image-wrapper relative-position center">
            <img className="overlay-text-picture" src={image} alt={alt} />
            <div className='overlay-text-content left-align absolute-position popout-slow'>
                <h1>
                    {title}
                </h1>
                <h3>
                    {slogan}
                </h3>
            </div>
            <div className='overlay-bottom-text-content absolute-position center'>
                <h3 className='mobile-small-block-text'>
                    {text}
                </h3>
            </div>
        </div>
    )
}

export default OverlayTextImage;
